import { StyleSheet } from 'react-native';

export const { clickable } = StyleSheet.create({
  clickable: {
    cursor: 'pointer' as 'pointer',
    touchAction: 'manipulation',
  },
} as any);
